/**
 * Project-folder route builders: the file deep-link (#2281) and the folder
 * chat stage (6.7.6).
 *
 * Kept dependency-free so non-view code (the notification registry) can build
 * these links without importing hooks or stores: `folderChatPath` used to live
 * on `useStartFolderChat`, which a registry entry cannot call. Keep new
 * builders here dependency-free too.
 *
 * A citation to a project-folder file historically had no addressable target —
 * the viewer was reachable only through the `openFileInViewer` store action
 * (folder + filename, annotations handed over in memory), so backend-generated
 * hyperlinks could link no deeper than the folder. This route addresses one
 * file by its stable SDR id; FolderBrowser resolves `sdr_id -> fileName`
 * against the folder listing and reflects the URL into the viewer store, so a
 * cold-loaded link (pasted into a new tab) opens the document at the cited
 * page. `page_number`/`cid` mirror the dataset-document route
 * (`/datasets/:id/document/:sdr?page_number=&cid=`).
 */

export const PROJECT_FILE_ROUTE_PATH =
  "/assistant/projects/folder/:folder_id/file/:sdr_id";

export const projectFileViewerUrl = (
  folderId: number,
  sdrId: number,
  opts: { page?: number | null; chunkId?: number | null } = {},
): string => {
  let url = `/assistant/projects/folder/${folderId}/file/${sdrId}`;
  const params: string[] = [];
  if (opts.page != null) params.push(`page_number=${opts.page}`);
  if (opts.chunkId != null) params.push(`cid=${opts.chunkId}`);
  if (params.length) url += `?${params.join("&")}`;
  return url;
};

/** Route for a folder's chat stage (6.7.6). */
export const folderChatPath = (folderId: number, dialogueId: number) =>
  `/assistant/projects/folder/${folderId}/chat/${dialogueId}`;
